import { render, staticRenderFns } from "./ActiveUserBadge.vue?vue&type=template&id=d6bfbb7c&"
import script from "./ActiveUserBadge.vue?vue&type=script&lang=js&"
export * from "./ActiveUserBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ActiveUserBadge.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBadge,
  VCard,
  VContainer,
  VFlex,
  VLayout,
})
